import axios from 'axios';

import { PRICING_API_ENDPOINT } from 'constants/api';

const pricingAPI = axios.create({
  baseURL: PRICING_API_ENDPOINT,
});

export default pricingAPI;
